import React from "react";
import ServicesBento from "../components/ServicesBento";
import Pricing from "../components/Pricing";
import Reveal from "../components/Reveal";
import RevealLines from "../components/RevealLines";
import Marquee from "../components/Marquee";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Services() {
  return (
    <div data-testid="page-services">
      {/* Page header */}
      <section className="pt-32 lg:pt-44 pb-16 lg:pb-24 border-b border-line">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal y={12}>
            <span className="overline text-clay">SERVICII & PACHETE</span>
          </Reveal>
          <div className="mt-6">
            <RevealLines
              className="font-display font-black text-5xl sm:text-6xl lg:text-[104px] tracking-[-0.04em]"
              lines={[
                <span key="l1">Ce facem</span>,
                <span key="l2">
                  <span className="italic font-light">bine.</span>
                  <span className="text-clay"> Cu totul.</span>
                </span>,
              ]}
            />
          </div>
          <Reveal delay={0.6} y={16} className="mt-8 max-w-2xl">
            <p className="text-inksoft text-base lg:text-lg leading-relaxed">
              De la reparații de laptop-uri, la infrastructuri de rețea, la
              site-uri live — construim IT-ul afacerilor mici să meargă ca la
              cele mari.
            </p>
          </Reveal>
        </div>
      </section>

      <ServicesBento />
      <Marquee
        words={["Reparații", "Rețele", "CCTV", "Web", "Cloud", "Suport"]}
        speed={80}
        className="bg-sand"
      />
      <Pricing />

      {/* Bottom CTA */}
      <section className="py-24 lg:py-32 border-t border-line">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <Reveal>
            <h3 className="font-display text-3xl lg:text-4xl font-bold tracking-[-0.03em] max-w-xl">
              Nu găsești ce cauți? Discutăm oricum.
            </h3>
          </Reveal>
          <Reveal delay={0.1}>
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 px-7 py-5 rounded-full bg-ink text-sand font-semibold text-sm hover:bg-clay hover:text-white transition-colors"
            >
              Contact
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
